export interface FormattedOdds {
  american: string;
  decimal: string;
  fractional: string;
}

export interface Media {
  file: File;
  preview: string;
  type: string;
}

export type PriceType = 'FREE' | 'PREMIUM' | 'PAID';

export enum PRICE_TYPES {
  FREE = 'FREE',
  PREMIUM = 'PREMIUM',
  PAID = 'PAID',
}

export type OddsFormat = 'DECIMAL' | 'AMERICAN' | 'FRACTIONAL';

export interface FormMediafile {
  file: File | Object;
  type: string;
  preview: string;
}
export interface Bookie {
  id: string;
  code: string;
  name: string;
  logo_url: { ios: string; android: string; web: string };
  url: string;
  is_active: boolean;
}
export type Sport = {
  id: string;
  code: string;
  name: string;
  active: boolean;
};
export type Market = {
  code: string;
};
export type Stake =
  | 1
  | 1.5
  | 2
  | 2.5
  | 3
  | 3.5
  | 4
  | 4.5
  | 5
  | 5.5
  | 6
  | 6.5
  | 7
  | 7.5
  | 8
  | 8.5
  | 9
  | 9.5
  | 10;
